import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';


const theme = createMuiTheme({
    overrides: {
        MuiSnackbarContent: {
            root: {
                backgroundColor: '#DD3636'
            }
        }
    }
});

export default function AppErrorAlert({ dialogOpen, dialogText, onClickHandler, close }) {
    const snackbarMessage = () =>
            <div>
                <ErrorOutlineOutlinedIcon style={{ verticalAlign: 'middle', paddingRight: '8px' }} />{dialogText}
            </div>
    return (
        <MuiThemeProvider theme={theme}>
            <div style={{zIndex: 1000000}}>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={dialogOpen}
                    data-metrics-location='PU'
                    autoHideDuration={6000}
                    onClose={close}
                    message={snackbarMessage()}
                    id='error-notification'
                    action={
                        <>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={onClickHandler}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </>
                    }
                />
            </div>
        </MuiThemeProvider>

    );
}
